// exports DiagnosisInitiatorType - an immutable object 'enum'
// usage: import { DiagnosisInitiatorType } from '../../enums/DiagnosisInitiatorType';
const diagnosisInitiatorType = {
    UserEntered: 1,
    Claim: 2,
    RiskMitigation: 3,
    NLPInsights: 5
};
Object.freeze(diagnosisInitiatorType);
export const DiagnosisInitiatorType = diagnosisInitiatorType;